import { onMounted, onBeforeUnmount } from 'vue';
import { useCommonData } from '@/hooks';

export function useIdleActivity({ delay = 1000, onActive, onInactive }) {
	let timer = null;
	let isActive = true;

	const { viewInIframe } = useCommonData();

	const reset = () => {
		if (timer) clearTimeout(timer);

		if (!isActive) {
			isActive = true;
			onActive?.();
		}

		timer = setTimeout(() => {
			isActive = false;
			onInactive?.();
		}, delay);
	};

	onMounted(() => {
		if (viewInIframe.value) return;
		window.addEventListener('mousemove', reset);
	});

	onBeforeUnmount(() => {
		if (viewInIframe.value) return;
		window.removeEventListener('mousemove', reset);
		timer && clearTimeout(timer);
	});
}
